<template>
  <!-- <div v-if="consun([item])"> -->
  <div v-if="isShow">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link
        v-if="onlyOneChild.meta"
        :to="item.meta.isshow == false ? resolvePath(onlyOneChild.path) : ''"
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
          :disabled="item.meta.isshow"
          :text-color="item.meta.isshow ? '#fff' : ''"
        >
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta.icon"
          :title="item.meta.title"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShow () {
      const roles = this.item.meta ? this.item.meta.roles || [] : []
      return hasPermission(roles)
    }
  },
  data () {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  created () {},

  methods: {
    consun (val) {
      for (let i = 0; i < val.length; i += 1) {
        if (val[i].children && val[i].children.length) {
          this.consun(Item.children)
        }
        if (item.meta && Item.meta.roles && Item.meta.roles.length > 0) {
          for (let j = 0; j < val.length; j += 1) {
            if (item[j].meta.roles.indexOf('2') > -1) {
              return
            }
          }
        }
      }
    },
    hasOneShowingChild (children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) return false
        if (!item.meta || !item.meta.title) return false
        const roles = item.meta.roles || []
        if (roles.length && !hasPermission(roles)) return false
        this.onlyOneChild = item
        return true
      })

      if (showingChildren.length === 1) {
        this.onlyOneChild = showingChildren[0]
        return true
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      this.onlyOneChild = showingChildren[0]
      return false
    },
    resolvePath (routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/SidebarItem.vue